<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc1"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">The Deadly Grounds of Old Trinity Church, Brooklyn</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Israel Putnam’s Gravesite and the Mortlake Manor, Brooklyn</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">The <i>Charles W. Morgan</i> and the Buckingham House, Mystic Seaport</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">The Whitehall Mansion, Mystic</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Elizabeth Shaw and the Windham Inn, Windham</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">The White Horse Inn at Vernon Stiles Restaurant, Thompson</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">The Bloody Orchard, Franklin</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">The Lighthouse Inn, New London</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Eugene O’Neill’s Monte Cristo Cottage, New London</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Route 138—A Cruise Down the Vampire Highway, Jewett City</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Harvest Restaurant, Pomfret</span></p>
<p class="toc1"><span href="#/endnotes" title="Link target outside of Sample">Endnotes</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5a82d4f1